<template>
  <div class="loader"></div>
</template>

<style scoped>
.loader {
  width: 80px;
  aspect-ratio: 1;
  border: 10px solid #FFF;
  box-sizing: border-box;
  background: radial-gradient(farthest-side, #000 98%, #FFF) top,
  radial-gradient(farthest-side, #000 98%, #FFF) top,
  radial-gradient(farthest-side, #000 98%, #FFF) left,
  radial-gradient(farthest-side, #000 98%, #FFF) right,
  radial-gradient(farthest-side, #000 98%, #FFF) bottom,
  #FFF;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  filter: blur(4px) contrast(10);
  animation: l19 2s infinite;
}

@keyframes l19 {
  0% {
    background-position: top, top, left, right, bottom
  }
  25% {
    background-position: right, top, left, right, bottom
  }
  50% {
    background-position: bottom, top, left, right, bottom
  }
  75% {
    background-position: left, top, left, right, bottom
  }
  100% {
    background-position: top, top, left, right, bottom
  }
}
</style>
<script setup lang="ts">
</script>